import { Box, styled, Theme } from "@mui/material";
import {
  TOP_NAV_HEIGHT_DESKTOP,
  TOP_NAV_MENU_HEIGHT_LARGE,
} from "./GlobalMenu";
import { useTopNavHeadroom } from "./useTopNavHeadroom";
import { HIDE_SCROLLBAR_STYLE, HOVER_SCROLLBAR_STYLE } from "./LayoutConstants";

interface StickyBoxProps {
  isCollapsed: boolean;
  noSubnav?: boolean;
  showScrollbar?: boolean;
  noPadding?: boolean;
}
const StickyBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => {
    return (
      prop !== "isCollapsed" &&
      prop !== "noSubnav" &&
      prop !== "showScrollbar" &&
      prop !== "noPadding"
    );
  },
})<StickyBoxProps>(
  ({
    theme,
    isCollapsed,
    noSubnav,
    showScrollbar,
    noPadding,
  }: { theme: Theme } & StickyBoxProps) =>
    theme.unstable_sx({
      position: "sticky",
      top: `calc(${theme.spacing(!noPadding ? 0 : 2)} + ${isCollapsed ? 2 : noSubnav ? TOP_NAV_MENU_HEIGHT_LARGE : TOP_NAV_HEIGHT_DESKTOP}px)`,
      transition: theme.transitions.create(["top", "height"], {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),
      maxHeight: `calc(100vh - ${theme.spacing(isCollapsed ? 2 : 4)} - ${isCollapsed ? 0 : noSubnav ? TOP_NAV_MENU_HEIGHT_LARGE : TOP_NAV_HEIGHT_DESKTOP}px)`,
      overflowY: "auto",
      overflowX: "hidden",
      padding: noPadding ? 0 : theme.spacing(2, 4),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2, 1),
        maxHeight: "initial",
      },
      ...(!showScrollbar
        ? HIDE_SCROLLBAR_STYLE
        : {
            ...HOVER_SCROLLBAR_STYLE,
          }),
    }),
);

export function StickyBox({
  children,
  noSubnav,
  noPadding,
  showScrollbar,
}: {
  children: React.ReactNode;
  noSubnav?: boolean;
  noPadding?: boolean;
  showScrollbar?: boolean;
}) {
  const { isCollapsed } = useTopNavHeadroom();

  return (
    <StickyBoxContainer
      isCollapsed={isCollapsed}
      noSubnav={noSubnav}
      showScrollbar={showScrollbar}
      noPadding={noPadding}
    >
      {children}
    </StickyBoxContainer>
  );
}
